const headerTexts = {
  wholesale: "Atacado",
  support: "Suporte",
  profile: "Perfil",
  orders: "pedidos",
  leave: "sair",
};

export default headerTexts;
